import { Grid } from '@mui/material';

import type { AdFieldFloorEnum, AdFieldOccupancyEnum } from '@/types';
import { FiltersBlock } from './FiltersBlock';
import { icons } from './Icons';

interface FilterOption<T> {
  label: string;
  value: T;
}

interface FloorAvailabilitySectionProps {
  availability: AdFieldOccupancyEnum[];
  availabilityOptions: FilterOption<AdFieldOccupancyEnum>[];
  availabilityVisible: boolean;
  floor: AdFieldFloorEnum[];
  floorOptions: FilterOption<string>[];
  floorVisible: boolean;
  onAvailabilityChange: (value: AdFieldOccupancyEnum, name?: string) => void;
  onFloorChange: (value: AdFieldFloorEnum | string, name?: string) => void;
}

export const FloorAvailabilitySection = ({
  availability,
  availabilityOptions,
  availabilityVisible,
  floor,
  floorOptions,
  floorVisible,
  onAvailabilityChange,
  onFloorChange,
}: FloorAvailabilitySectionProps) => {
  return (
    <>
      {floorVisible && (
        <Grid item xs={12}>
          <FiltersBlock
            icon={<icons.Floor />}
            name='floor'
            type='button'
            size='big'
            title='Floor'
            options={floorOptions}
            activeButton={floor}
            onClick={onFloorChange}
            dataQa='floor'
          />
        </Grid>
      )}
      {availabilityVisible && (
        <Grid item xs={12}>
          <FiltersBlock
            icon={<icons.Availability />}
            name='occupancy'
            type='button'
            size='big'
            title='Availability'
            options={availabilityOptions}
            activeButton={availability}
            onClick={onAvailabilityChange}
            dataQa='availability'
          />
        </Grid>
      )}
    </>
  );
};
